
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Impressum',

    metaInfo: { title: 'Impressum' },

    extends: View,

    // killed: affiliates
    mixins: [
      LoadSections([
        'hero-alt',
        'impressum',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'impressum',
      },
    },
  }
</script>
